<script>
import Auth from '~/components/layouts/auth.vue';
import Canvas from '~/components/layouts/canvas.vue';
import Dashboard from '~/components/layouts/dashboard.vue';
import Default from '~/components/layouts/default.vue';

export default {
    computed: {
        ...mapState(useLayoutStore, ['layout']),
        ...mapGetters(useAuthStore, ['hasSession']),
        ...mapGetters(useResponseStore, ['htmlError', 'errors', 'code']),
    },
    components: {
        'auth': Auth,
        'dashboard': Dashboard,
        'default': Default,
        'canvas': Canvas,
    },
    methods: {
        ...mapActions(useAuthStore, ['loadSession']),
        ...mapActions(useModuleStore, ['getModule']),
        ...mapActions(useVersionStore, ['getVersion']),
        ...mapActions(useConfigurationStore, ['fetchAll']),
        showToast(message) {
            this.$swal({
                icon: 'success',
                position: 'top-end',
                showConfirmButton: false,
                text: message,
                timer: 3000,
                timerProgressBar: true,
                toast: true,
                showCloseButton: true,
            });
        },
        showToastDeleteInfo() {
            this.$swal({
                icon: 'info',
                position: 'top-end',
                showConfirmButton: false,
                text: this.$t('Data Successfully Deleted'),
                timer: 3000,
                timerProgressBar: true,
                toast: true,
            })
        },
        remove(store) {
            this.$swal({
                title: this.$t('Confirm Delete?'),
                text: this.$t('Data Will Not Be Restored!'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('Yes, Delete!!')
            }).then((result) => {
                if (result.isConfirmed) {
                    store.remove(store.data.id).then(async (res) => {
                        store.setView();
                        await this.$router.replace(`${store.route}`);
                        this.$root.showToastDeleteInfo();
                    }).catch(err => { });
                }
            }).catch(err => { });
        },
        submit(store, method) {
            store.submitForm(method, store.form)
                .then(async res => {
                    store.setView();
                    if (method == "POST") this.$router.replace(res.data.id.toString());
                    this.showToast(res.message)
                })
                .catch(err => { });
        },
        handleBootstrapError() {
            if (this.errors != null) {
                return;
            }
            this.$swal({
                icon: 'error',
                title: this.$t('Something is wrong!'),
                text: this.$t('Unable to load application data. Please try again.'),
                confirmButtonText: this.$t('OK'),
            });
        },
        async bootstrap() {
            try {
                await this.loadSession();
                await Promise.all([
                    this.getModule(),
                    this.getVersion(),
                    this.fetchAll({
                        skipPagination: true,
                    }),
                ]);
            } catch (error) {
                this.handleBootstrapError();
            }
        },
    },
    created() {
        this.bootstrap();
    },
    watch: {
        errors(value) {
            if (this.errors != null) {
                let title = this.$t('Something is wrong!')
                let icon = 'error';
                if (this.code <= 499) icon = 'warning';
                if (this.code == 400) title = this.$t('Request Cannot Be Processed');
                if (this.code <= 399) icon = 'info';
                if (this.code <= 299) icon = 'success';
                this.$swal({
                    icon: icon,
                    position: 'center',
                    showConfirmButton: false,
                    title: title,
                    html: this.htmlError,
                    timer: 3000,
                });
            }
        }
    }
}
</script>

<template>
    <component :is="layout"></component>
</template>
